export enum SCROLL_ZOOM_MODE {
  ALWAYS,
  NEVER,
  ON_SHIFT,
}
